import { Inject, Injectable } from '@angular/core'
import { SESSION_STORAGE, StorageService } from 'angular-webstorage-service'
import { BehaviorSubject } from 'rxjs'

const STORAGE_KEY = 'hub_target_it_'

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    public localStorageChanged: BehaviorSubject<any> = new BehaviorSubject<any>(null)

    constructor(@Inject(SESSION_STORAGE) private storage: StorageService) { }

    public set(key, value) {
        this.storage.set(STORAGE_KEY + key, value)
        return this.localStorageChanged.next(key)
    }

    public get(key) {
        return this.storage.get(STORAGE_KEY + key)
    }

    public remove(key) {
        return this.storage.remove(STORAGE_KEY + key)
    }
}
